// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterWrapper__wrapper___2olBY","title":"FilterWrapper__title___1GMZB"};